<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="importAction" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalRemisionVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          input(type="file" ref="file" @change="handleFileUpload()" accept="application/pdf")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("gallery.description_placeholder")' v-model="remision.description" :label='$t("gallery.description")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("gallery.date")' v-model="remision.date")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalRemision',
  props: {
    remision: {
      type: Object
    },
    shipment: {
      type: Number
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  validations: {
  },
  computed: {
    ...mapGetters([
      'isModalRemisionVisible',
      'inOrder'
    ]),
    imageValidate () {
      return this.files.length < 1
    },
    getTitle () {
      return this.isAdd ? 'Add Bill of Materials' : 'Edit Bill of Materials'
    }
  },
  data: () => ({
    files: []
  }),
  methods: {
    ...mapActions([
      'setModalRemisionVisible',
      'addRemisionShipment',
      'editRemisionShipment'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      this.files = this.$refs.file.files
    },
    importAction () {
      this.isAdd
        ? this.addRemisionShipment({
          remision: this.remision,
          file: this.file,
          thumbnail: this.file.name.replace(/(\.[\w\d_-]+)$/i, '_thumbnail$1'),
          mime_type: this.file.type,
          project_id: this.inOrder.id
        })
        : this.editRemisionShipment({
          remision: this.remision,
          file: this.file,
          thumbnail: this.file.name.replace(/(\.[\w\d_-]+)$/i, '_thumbnail$1'),
          mime_type: this.file.type,
          project_id: this.inOrder.id
        })
    },
    close () {
      this.setModalRemisionVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
</style>
